var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormatSize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10V19C6 19.5439 6.45614 20 7 20C7.54386 20 8 19.5439 8 19V10C8 9.45614 7.54386 9 7 9C6.45614 9 6 9.45614 6 10ZM4 11H10C10.5439 11 11 10.5439 11 10C11 9.45614 10.5439 9 10 9H4C3.45614 9 3 9.45614 3 10C3 10.5439 3.45614 11 4 11ZM14 5V19C14 19.5439 14.4561 20 15 20C15.5439 20 16 19.5439 16 19V5C16 4.45614 15.5439 4 15 4C14.4561 4 14 4.45614 14 5ZM10 6H20C20.5439 6 21 5.54386 21 5C21 4.45614 20.5439 4 20 4H10C9.45614 4 9 4.45614 9 5C9 5.54386 9.45614 6 10 6Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatSize);
export default __webpack_public_path__ + "static/media/format_size.46ab6216.svg";
export { ForwardRef as ReactComponent };